const swiperEl = document.querySelector('.swiper-our-team');

if (swiperEl) {
  const swiperOurTeam = new Swiper(swiperEl, {
    loop: true,
    slidesPerView: 4.5,
    spaceBetween: 16,
    speed: 600,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 16,
      },
      640: {
        slidesPerView: 1.5,
        spaceBetween: 16,
      },
      768: {
        slidesPerView: 2.5,
        spaceBetween: 16,
      },
      1200: {
        slidesPerView: 3.5,
        spaceBetween: 16,
      },
      1350: {
        slidesPerView: 4.5,
        spaceBetween: 16,
      },
    },
  });

  // Pause autoplay on hover
  swiperEl.addEventListener('mouseenter', () => swiperOurTeam.autoplay?.stop());
  swiperEl.addEventListener('mouseleave', () => swiperOurTeam.autoplay?.start());
}
